import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "client-invoice-list" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "invoice-cell projectName hierarchy-cell client-name" }
const _hoisted_4 = ["aria-expanded", "onClick"]
const _hoisted_5 = { class: "client-label" }
const _hoisted_6 = { class: "invoice-cell ordersTotal" }
const _hoisted_7 = { class: "invoice-cell performedTimesheetsTotal" }
const _hoisted_8 = { class: "invoice-cell totalExpensesNet" }
const _hoisted_9 = { class: "invoice-cell totalUninvoicedOfferedNet" }
const _hoisted_10 = { class: "invoice-cell invoicedTotal" }
const _hoisted_11 = { class: "invoice-cell toInvoice" }
const _hoisted_12 = { class: "invoice-cell toInvoiceGross" }
const _hoisted_13 = { class: "invoice-cell reportStatus" }
const _hoisted_14 = ["title"]
const _hoisted_15 = ["aria-label", "onClick"]
const _hoisted_16 = {
  key: 0,
  class: "comments-count"
}
const _hoisted_17 = {
  key: 0,
  class: "client-projects"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "invoice-cell projectName hierarchy-cell project-name" }
const _hoisted_20 = ["title"]
const _hoisted_21 = { class: "project-label" }
const _hoisted_22 = { class: "invoice-cell ordersTotal" }
const _hoisted_23 = { class: "invoice-cell performedTimesheetsTotal" }
const _hoisted_24 = { class: "invoice-cell totalExpensesNet" }
const _hoisted_25 = { class: "invoice-cell totalUninvoicedOfferedNet" }
const _hoisted_26 = { class: "invoice-cell invoicedTotal" }
const _hoisted_27 = { class: "invoice-cell toInvoice" }
const _hoisted_28 = { class: "invoice-cell toInvoiceGross" }
const _hoisted_29 = { class: "invoice-cell reportStatus" }
const _hoisted_30 = {
  key: 1,
  class: "empty-option-icon"
}
const _hoisted_31 = {
  ref: "endOfList",
  class: "end-of-list"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_DropDownItem = _resolveComponent("DropDownItem")!
  const _component_DropdownMenu = _resolveComponent("DropdownMenu")!
  const _component_OnClickOutside = _resolveComponent("OnClickOutside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.paginatedResult)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.paginatedResult.items, (client) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: client.id
            }, [
              _createElementVNode("ul", {
                class: "invoice-row client-row",
                onClick: ($event: any) => (_ctx.toggleClient(client.id))
              }, [
                _createElementVNode("li", _hoisted_3, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "expand-button",
                    "aria-expanded": _ctx.isClientExpanded(client.id),
                    onClick: _withModifiers(($event: any) => (_ctx.toggleClient(client.id)), ["stop"])
                  }, [
                    _createVNode(_component_Icon, {
                      icon: "entypo:triangle-right",
                      rotate: _ctx.isClientExpanded(client.id) ? 1 : 0,
                      class: "expand-icon"
                    }, null, 8, ["rotate"])
                  ], 8, _hoisted_4),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(client.clientName), 1)
                ]),
                _createElementVNode("li", _hoisted_6, _toDisplayString(_ctx.formatPrice(client.ordersTotal)), 1),
                _createElementVNode("li", _hoisted_7, _toDisplayString(_ctx.formatPrice(client.performedTimesheetsTotal)), 1),
                _createElementVNode("li", _hoisted_8, _toDisplayString(_ctx.formatPrice(client.totalExpensesNet)), 1),
                _createElementVNode("li", _hoisted_9, _toDisplayString(_ctx.formatPrice(client.totalUninvoicedOfferedNet)), 1),
                _createElementVNode("li", _hoisted_10, _toDisplayString(_ctx.formatPrice(client.invoicedTotal)), 1),
                _createElementVNode("li", _hoisted_11, _toDisplayString(_ctx.formatPrice(client.toInvoice)), 1),
                _createElementVNode("li", _hoisted_12, _toDisplayString(_ctx.formatPrice(client.toInvoiceGross)), 1),
                _createElementVNode("li", _hoisted_13, _toDisplayString(_ctx.getClientStatus(client.projects)), 1),
                _createElementVNode("li", {
                  class: "option-icon comments-button-cell",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                }, [
                  (client.hasUnvalidatedOfferedAmount)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "offered-warning",
                        title: _ctx.t('labels.offered.tooltip')
                      }, [
                        _createVNode(_component_Icon, {
                          icon: "bi:exclamation-circle",
                          class: "offered-warning-icon"
                        })
                      ], 8, _hoisted_14))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["comments-button", { 'has-comments': client.commentsCount > 0 }]),
                    "aria-label": 
                _ctx.t('comments.title', { clientName: client.clientName })
              ,
                    onClick: ($event: any) => (_ctx.emitShowComments(client.id, client.clientName, $event))
                  }, [
                    _createVNode(_component_Icon, {
                      icon: "bi:chat-left-text",
                      class: "comments-icon"
                    }),
                    (client.commentsCount > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(client.commentsCount), 1))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_15)
                ])
              ], 8, _hoisted_2),
              (_ctx.isClientExpanded(client.id))
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(client.projects, (project) => {
                      return (_openBlock(), _createElementBlock("ul", {
                        key: project.id,
                        class: "invoice-row project-row",
                        onClick: ($event: any) => (_ctx.emitActionOnClick(project))
                      }, [
                        _createElementVNode("li", _hoisted_19, [
                          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "project-indent" }, null, -1)),
                          (_ctx.hasOfferedAmountOnProject(project))
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "offered-warning",
                                title: _ctx.t('labels.offered.tooltip')
                              }, [
                                _createVNode(_component_Icon, {
                                  icon: "bi:exclamation-circle",
                                  class: "offered-warning-icon"
                                })
                              ], 8, _hoisted_20))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", _hoisted_21, _toDisplayString(project.projectName), 1)
                        ]),
                        _createElementVNode("li", _hoisted_22, _toDisplayString(_ctx.formatPrice(project.ordersTotal)), 1),
                        _createElementVNode("li", _hoisted_23, _toDisplayString(_ctx.formatPrice(project.performedTimesheetsTotal)), 1),
                        _createElementVNode("li", _hoisted_24, _toDisplayString(_ctx.formatPrice(project.totalExpensesNet)), 1),
                        _createElementVNode("li", _hoisted_25, _toDisplayString(_ctx.formatPrice(project.totalUninvoicedOfferedNet)), 1),
                        _createElementVNode("li", _hoisted_26, _toDisplayString(_ctx.formatPrice(project.invoicedTotal)), 1),
                        _createElementVNode("li", _hoisted_27, _toDisplayString(_ctx.formatPrice(project.toInvoice)), 1),
                        _createElementVNode("li", _hoisted_28, _toDisplayString(_ctx.formatPrice(project.toInvoiceGross)), 1),
                        _createElementVNode("li", _hoisted_29, _toDisplayString(project.draftInvoice ? "draft" : "new"), 1),
                        _createElementVNode("li", {
                          class: "option-icon draft-dropdown-cell",
                          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                        }, [
                          (project.draftInvoice)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "dropdown-wrapper",
                                ref_for: true,
                                ref: 
                  (element) => {
                    _ctx.getRef(element as HTMLElement, project.id);
                  }
                
                              }, [
                                _createVNode(_component_OnClickOutside, { onTrigger: _ctx.closeDropdown }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_IconButton, {
                                      class: "draft-download-button",
                                      iconName: "bi:cloud-download",
                                      hasBorders: false,
                                      onClick: _withModifiers(($event: any) => (_ctx.toggleDropdown(project.id)), ["stop"])
                                    }, null, 8, ["onClick"]),
                                    (_ctx.isDropdownActive(project.id))
                                      ? (_openBlock(), _createBlock(_component_DropdownMenu, {
                                          key: project.id,
                                          reference: _ctx.targetElements[project.id]
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_DropDownItem, {
                                              label: _ctx.t('dropDownMenu.download.timesheetsInDraft'),
                                              iconName: "akar-icons:download",
                                              href: `${_ctx.backendUri}/documents/reports/draft-invoice/${project.draftInvoice.id}`,
                                              target: "_blank"
                                            }, null, 8, ["label", "href"])
                                          ]),
                                          _: 2
                                        }, 1032, ["reference"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["onTrigger"])
                              ], 512))
                            : (_openBlock(), _createElementBlock("div", _hoisted_30))
                        ])
                      ], 8, _hoisted_18))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_31, [
      _withDirectives(_createElementVNode("div", { class: "loading apollo" }, _toDisplayString(_ctx.t("loading")), 513), [
        [_vShow, _ctx.loading]
      ])
    ], 512)
  ], 64))
}